<template>
  <div class="st_p-wrapper">
    <TopNav />

    <div class="settings mtb15">
      <div class="container-fluid">
        <div class="row">
          <Menu />

          <div class="col-md-12 col-lg-9">
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="settings-profile"
                role="tabpanel"
                aria-labelledby="settings-profile-tab"
              >
                <div class="card mb-4">
                  <div class="card-body">
                    <h5 class="card-title">Informasi Umum</h5>

                    <!-- <div class="custom-file">
                      <input type="file" class="custom-file-input" id="fileUpload" ref="fileInput">
                      <label class="custom-file-label" for="fileUpload">Choose avatar</label>

                      <button @click="uploadFile">Upload</button>
                    </div> -->

                    <div class="settings-profile">
                      <form @submit.prevent="submitForm">
                        <!-- <img src="assets/img/avatar.svg" alt="avatar" >
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" id="fileUpload" >
                          <label class="custom-file-label" for="fileUpload">Choose avatar</label>
                        </div> -->
                        <div class="form-row mt-4">
                          <div class="col-md-6">
                            <label>Nama Lengkap</label>
                            <h4 class="profile-readonly-value">
                              {{ user.orang_name }}
                            </h4>
                          </div>
                          <div class="col-md-6">
                            <label for="formLast">Panggilan</label>
                            <input
                              id="formLast"
                              type="text"
                              class="form-control"
                              placeholder="Panggilan"
                              v-model="user.orang_nickname"
                            />
                          </div>
                          <div class="col-md-6">
                            <label>Email</label>
                            <h4 class="profile-readonly-value">
                              {{ user.orang_email }}
                            </h4>
                          </div>
                          <!-- <div class="col-md-6">
                            <label for="phoneNumber">Telepon</label>
                            <input
                              id="phoneNumber"
                              type="text"
                              class="form-control"
                              placeholder="Enter phone number"
                            />
                          </div> -->

                          <div class="col-md-12">
                            <input
                              type="submit"
                              value="Perbarui"
                              @click="submit"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">Ganti Password</h5>

                    <div class="settings-profile">
                      <form @submit.prevent="submitPasswordChange">
                        <div class="form-row mt-4">
                          <div class="col-md-6">
                            <label for="oldPassword">Password Saat Ini</label>
                            <div class="form-group position-relative mb-3">
                              <input
                                id="oldPassword"
                                type="password"
                                class="form-control"
                                placeholder="Password saat ini"
                                ref="oldPassword"
                                v-model="old_password"
                                autocomplete="current-password"
                              />
                              <TogglePassword
                                @is-password-show="toggleOldPasswordValue"
                              />
                            </div>
                          </div>
                          <div class="col-md-6"></div>
                          <div class="col-md-6">
                            <label for="newPassword">Password Baru</label>
                            <div class="form-group position-relative mb-3">
                              <input
                                id="newPassword"
                                type="password"
                                class="form-control"
                                placeholder="Password baru"
                                ref="newPassword"
                                v-model="new_password"
                                autocomplete="new-password"
                              />
                              <TogglePassword
                                @is-password-show="toggleNewPasswordValue"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="newPasswordConfirmation"
                              >Konfirmasi Password Baru</label
                            >
                            <div class="form-group position-relative mb-3">
                              <input
                                id="newPasswordConfirmation"
                                type="password"
                                class="form-control"
                                placeholder="Ketik ulang password baru"
                                ref="newPasswordConfirmation"
                                v-model="new_password_confirmation"
                                autocomplete="new-password"
                              />
                              <TogglePassword
                                @is-password-show="
                                  toggleNewPasswordConfirmationValue
                                "
                              />
                            </div>
                          </div>

                          <div class="col-md-12">
                            <input
                              v-if="!isPasswordLoading"
                              type="submit"
                              value="Ganti Password"
                            />
                            <input
                              v-else
                              type="button"
                              value="Loading..."
                              disabled
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";
import axios from "axios";
import { useToast } from "vue-toastification";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";
import {
  isPasswordValid,
  PASSWORD_ERROR_MESSAGE,
} from "@/applibs/passwordPolicy.js";

// components
import TopNav from "@/components/global/TopNav.vue";
import Footer from "@/components/global/Footer.vue";
import Menu from "@/components/Settings/Menu.vue";
import TogglePassword from "@/components/global/TogglePassword.vue";

const toast = useToast();

export default {
  components: {
    TopNav,
    Footer,
    Menu,
    TogglePassword,
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      user: {},
      old_password: "",
      new_password: "",
      new_password_confirmation: "",
      isPasswordLoading: false,
    };
  },

  async beforeMount() {
    var self = this;
    // cek expire token
    if (self.token) {
      var res = await thestore.postCheckToken(self.token);
      if (res.success == false) {
        Cookies.remove("jwt");
        Cookies.remove("usid");
        self.$router.go();
      }
    }
  },

  async mounted() {
    var self = this;

    // ambil data dia ketika login
    if (self.token != null && self.token != "") {
      var res = await thestore.getMyProfileData(self.token);
      self.user = res;
    } else {
      self.$router.push("/");
    }
  },

  methods: {
    async submitForm() {
      var self = this;

      try {
        var res = await thestore.postMyProfileData(self.token, self.user);
        self.user = res;
        toast.success("Data berhasil di update");
      } catch (err) {
        console.log("Error: ", err);
      }
    },

    async submitPasswordChange() {
      var self = this;

      if (!self.old_password) {
        toast.warning("Password lama tidak boleh kosong");
        return;
      }
      if (!self.new_password) {
        toast.warning("Password baru tidak boleh kosong");
        return;
      }
      if (self.new_password === self.old_password) {
        toast.warning("Password baru tidak boleh sama dengan password lama");
        return;
      }
      if (self.new_password !== self.new_password_confirmation) {
        toast.warning("Password dan konfirmasi password tidak sama");
        return;
      }
      if (!isPasswordValid(self.new_password)) {
        toast.warning(PASSWORD_ERROR_MESSAGE);
        return;
      }

      self.isPasswordLoading = true;

      try {
        var res = await thestore.postChangePassword(
          self.token,
          self.old_password,
          self.new_password,
          self.new_password_confirmation
        );
        if (res.success == true) {
          toast.success(res.msg);
          Cookies.remove("jwt");
          Cookies.remove("usid");
          self.$router.push("/auth/login");
        } else {
          toast.warning(res.msg);
        }
      } catch (err) {
        console.log("Error: ", err);
        toast.warning("Terjadi kesalahan. Silakan coba lagi.");
      } finally {
        self.isPasswordLoading = false;
      }
    },

    toggleOldPasswordValue(val) {
      const input = this.$refs.oldPassword;
      input.type = val ? "text" : "password";
    },

    toggleNewPasswordValue(val) {
      const input = this.$refs.newPassword;
      input.type = val ? "text" : "password";
    },

    toggleNewPasswordConfirmationValue(val) {
      const input = this.$refs.newPasswordConfirmation;
      input.type = val ? "text" : "password";
    },

    uploadFile() {
      var self = this;

      const file = this.$refs.fileInput.files[0];
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(`${themain.baseApi}/users/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            JWT: self.token,
          },
        })
        .then(() => {
          // upload succeeded
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.profile-readonly-value {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  padding: 10px 0;
  line-height: 1.5;
  word-break: break-word;
  color: #be9e62;
}
</style>
